<template>
  <div class="download-carousel por">
    <carousel loop :autoplay="list.length > 1" dots="none" arrow="never" class="carousel w100 h100 por zi0"
              height="288px"
              v-model="value">
      <carousel-item v-for="(src, i) in list" :key="i" class="por">
        <img :src="src" alt="" class="carousel-img vat w100 abs-mc">
      </carousel-item>
    </carousel>
    <div class="w100 h100" v-show="length > 1">
      <div class="curr-ico img-left abs-m csp zi1"
           @click="value = ((value || length) - 1) % length"></div>
      <div class="curr-ico img-right abs-m csp zi1"
           @click="value = (value + 1) % length"></div>
    </div>
  </div>
</template>

<script>
  export default {
    watch: {
      value(v) {
        this.$emit('input', v);
      },
    },
    props: {
      list: {
        type: Array,
        default() {
          return [];
        },
      },
      value: {
        type: Number,
        default: 0,
      }
    },
    computed: {
      length() {
        return this.list.length;
      },
    },
  }
</script>

<style scoped lang="less">
  @import "../../assets/less/function";

  .curr-ico {
    .spirit-mask(url(../../assets/images/download_icon.png));
    &.img-left {
      &:after {
        mask-position: -78px -2px;
      }
    }
    &.img-right {
      &:after {
        mask-position: -97px -2px;
      }
    }
  }

  .download-carousel {
    width: 528px;
    height: 288px;
    .curr-ico {
      background-color: rgba(0, 15, 34, .2);
      border-radius: 2px;
      &:after {
        width: 17px;
        height: 27px;
        background-color: #fff;
      }
    }
    .img-left {
      left: 16px;
    }
    .img-right {
      right: 16px;
    }
  }
</style>